import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Railsのform処理のsubmitボタン自動無効化等のUtilityを有効化
import Rails from 'rails-ujs'

/// /// Stylesheet //////
// reset
import 'stylesheets/foundation/reset'

/// /// JavaScript//////
// node_modules
import 'jquery/dist/jquery.min'
import 'popper.js/dist/umd/popper.min'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min'
import '@fortawesome/fontawesome-free/css/all.min'

// flocss
import 'stylesheets/foundation/default'

import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'

Rails.start()

// 共通画像
require.context('images/common', true, /\.(png|jpg|jpeg|svg|ico)$/)
// object配下のscssを全て読み込む
const importAll = (r) => r.keys().forEach(r)
importAll(require.context('stylesheets/object/', true, /\.scss$/))

// Sentryの初期化
Sentry.init({
  dsn: process.env.SENTRY_DNS,
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', 'tech-commit.jp']
    })
  ],
  tracesSampleRate: 0.1
})
